import readerFontFaces from '@excalidraw/excalidraw/readerFontFaces.json';

/**
 * JSS @font-face rules for the fonts used by Excalidraw diagrams, so that the
 * SVGs of diagrams (see @/lib/lexical/excalidrawDiagrams) render with the
 * right fonts outside the editor. The font files are self-hosted, and only
 * downloaded if a diagram on the page uses them. The list is generated by the
 * vendored Excalidraw build (excalidraw/build.mjs).
 */
export const excalidrawFontFaces = readerFontFaces.map(({ family, src, unicodeRange }) => ({
  fontFamily: family,
  src: `url('${src}') format('woff2')`,
  fontDisplay: 'swap',
  ...(unicodeRange && { unicodeRange }),
}));
